import { Skeleton } from "antd"
const Loader = () => {
    return (
        <div className="example">
            <Skeleton />
        </div>

    )
}
export default Loader;